export default __webpack_public_path__ + "static/media/Sign-bg.1a5efb6c.jpg";